class ProgressBar extends HTMLElement {
  constructor() {
    super();

    this.loadMoreBtn = document.querySelector(`load-more#${this.dataset.paginationId}`);

    if (this.loadMoreBtn !== null) {
      this.container = this.loadMoreBtn.dataset.container;
      this.loadMoreCountWrapper = this.loadMoreBtn.parentNode.querySelector('.load-more__product-count__wrapper');
      this.loadMoreCount = this.loadMoreCountWrapper.querySelector('.load-more__products-count');
      this.loadProgressBar = this.loadMoreBtn.parentNode.querySelector('.load-progress-bar');
      this.loadProgressBarInner = this.loadMoreBtn.parentNode.querySelector('.load-progress-bar__inner');
      this.gridContainer = document.querySelector(`#${this.container}`);
      this.gridItems = this.gridContainer.querySelectorAll('.grid__item:not(.grid__item--featured)');
      this.amount = this.gridItems.length;
      this.maxValue = this.loadProgressBar.getAttribute('max-products-amount');
      this.productsPerPage = this.loadMoreBtn.dataset.productsPerPage;
      this.progressWidth = Math.ceil((this.amount / this.maxValue) * 100);

      this.loadProgressBar.setAttribute('products-amount', this.amount);
      this.loadProgressBarInner.style.width = this.progressWidth + "%";
    }
  }

  updateWidth(trigger, loadedProducts, loadMoreBtn) {
    this.loadMoreBtn = loadMoreBtn;
    this.loadMoreBtn.classList.add('is-hidden');

    this.gridItems = this.loadMoreBtn.parentNode.querySelectorAll('.grid__item:not(.grid__item--featured)');
    this.loadMoreCountWrapper = this.loadMoreBtn.parentNode.querySelector('.load-more__product-count__wrapper');
    this.loadMoreCount = this.loadMoreCountWrapper.querySelector('.load-more__products-count');
    this.loadProgressBar = this.loadMoreBtn.parentNode.querySelector('.load-progress-bar');
    this.loadProgressBarInner = this.loadMoreBtn.parentNode.querySelector('.load-progress-bar__inner');


    this.loadMoreCountWrapper.classList.add(
      'is-hidden',
      'visibility-hidden-important'
    )
    this.loadProgressBarInner.classList.add('is-hidden')

    this.currentAmount = this.gridItems.length;
    this.loadMoreCount.textContent = this.currentAmount;

    this.loadProgressBar.setAttribute('products-amount', this.currentAmount);
    this.maxValue = this.loadProgressBar.getAttribute('max-products-amount');

    this.progressWidth = Math.ceil((this.currentAmount / this.maxValue) * 100);
    this.loadProgressBarInner.style.width = this.progressWidth + "%";

    if (trigger && loadedProducts) {
      this.changeFocus(loadedProducts);
    }

    if(this.currentAmount < this.maxValue) {
      this.loadMoreCountWrapper.classList.remove(
        'is-hidden',
        'visibility-hidden-important'
      )
      this.loadProgressBarInner.classList.remove('is-hidden');
      this.loadMoreBtn.classList.remove('is-hidden');
      return;
    }
  }

  changeFocus(loadedProducts) {
    this.gridItems[loadedProducts].querySelector('.product-form__input-wrap').focus({
      preventScroll: true
    });
  }
}
customElements.define('progress-bar', ProgressBar);
